"use client";
import React from 'react';
import { motion, Variants } from 'framer-motion';

interface MotionViewportProps {
  children: React.ReactNode;
  className?: string;
  variants?: Variants;
  once?: boolean;
  margin?: string;
}

const MotionViewport: React.FC<MotionViewportProps> = ({
  children,
  className,
  variants,
  once = true,
  margin = '0px 0px -10% 0px',
}) => {
  return (
    <motion.div data-component-id="src/components/common/MotionViewport.tsx:21:4" data-component-path="src/components/common/MotionViewport.tsx" data-component-line="21" data-component-end-line="29" data-component-file="MotionViewport.tsx" data-component-name="motion.div" data-component-content="%7B%22elementName%22%3A%22motion.div%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D"
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once, margin }}
      variants={variants}
    >
      {children}
    </motion.div>
  );
};

export default MotionViewport;
